/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
 */

import { NgModule } from '@angular/core';
import {CommonModule} from '@angular/common';
import {FcAgContextModule} from '../fc-ag-context/fc-ag-context.module';
import { FcResponsiveAgGridComponent } from './fc-responsive-ag-grid.component';
import {FcResponsiveAgGridDesktopComponent} from './fc-responsive-ag-grid-desktop.component';
import {FcResponsiveAgGridMobileComponent} from './fc-responsive-ag-grid-mobile.component';
import {FcResponsiveAgGridPagingComponent} from './fc-responsive-ag-grid-paging.component';
import {FcResponsiveAgGridModeButtonComponent} from './fc-responsive-ag-grid-mode-button.component';


/**
 * Grid module with Angular.
 */
@NgModule({
    declarations: [
        FcResponsiveAgGridComponent,
        FcResponsiveAgGridDesktopComponent,
        FcResponsiveAgGridMobileComponent,
        FcResponsiveAgGridPagingComponent,
        FcResponsiveAgGridModeButtonComponent
    ],
    imports: [
        CommonModule,
        FcAgContextModule
    ],
    exports: [
        FcResponsiveAgGridComponent,
        FcResponsiveAgGridDesktopComponent,
        FcResponsiveAgGridMobileComponent,
        FcResponsiveAgGridPagingComponent,
        FcResponsiveAgGridModeButtonComponent
    ]
})
export class FcResponsiveAgGridModule {
}